const de = {
  common: {
    loading: 'Wird geladen...',
    error: 'Fehler',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    close: 'Schließen',
    confirm: 'Bestätigen',
    search: 'Suchen',
    filter: 'Filtern',
    export: 'Exportieren',
    yes: 'Ja',
    no: 'Nein',
    back: 'Zurück',
    next: 'Weiter',
    submit: 'Absenden',
    darkMode: 'Dunkelmodus',
    lightMode: 'Hellmodus',
    languageMenuTitle: 'Sprache ändern',
    pagerShow: 'Zeigen',
    pagerPerPage: 'pro Seite',
    pagerOf: 'von',
    viewCards: 'Kartenansicht',
    viewList: 'Listenansicht',
    collapse: 'Einklappen',
    expand: 'Ausklappen',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    retry: 'Erneut versuchen',
    errorBoundaryTitle: 'Etwas ist schiefgelaufen',
    errorGeneric: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    expandModal: 'Im Modal erweitern',
    resetToGlobal: 'Auf Global zurücksetzen',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Startseite',
    growth: 'Wachstum',
    admin: 'Verwaltung',
    executive: 'Führung',
    analytics: 'Analytik',
    switchDemoProfile: 'Demo-Profil wechseln',
    mobileNav: 'Hauptnavigation',
  },
  roles: {
    employee: 'Mitarbeiter',
    adminOU: 'OE-Admin',
    adminGlobal: 'Global-Admin',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Ausstehende Umfragen',
    pending: 'Ausstehend',
    completed: 'Abgeschlossen',
    expired: 'Abgelaufen',
    submit: 'Bewertung einreichen',
    skip: 'Überspringen',
    noObs: 'Keine Beobachtung',
    meeting: 'Besprechung',
    duration: 'Dauer',
    participants: 'Teilnehmer',
    simulateMeeting: 'Besprechungsende simulieren',
    thankYou: 'Vielen Dank für Ihre Bewertung!',
    evaluating: 'Bewertet',
    of: 'von',
    question: 'Frage',
    selectResponse: 'Antwort auswählen',
    nps: {
      question: 'Wie wahrscheinlich ist es, dass Sie die Zusammenarbeit mit dieser Person empfehlen?',
      detractor: 'Kritiker',
      passive: 'Passiv',
      promoter: 'Befürworter',
    },
    evaluateNow: 'Jetzt bewerten',
    postpone: 'Später',
    expires: 'Läuft ab',
    noSurveysPending: 'Keine ausstehenden Umfragen! Gute Arbeit.',
    weekCompleted: 'Wo.',
    likert: {
      always: 'Immer',
      usually: 'Meistens',
      sometimes: 'Manchmal',
      rarely: 'Selten',
      notObservable: 'Nicht beobachtbar',
    },
    questions: {
      listenedActivelyText: 'Hat diese Person aktiv zugehört und echtes Interesse gezeigt?',
      sharedKnowledgeText: 'Hat sie relevantes Wissen oder Erfahrungen während der Sitzung geteilt?',
    },
    completeSubtitle: 'Ihr Feedback hilft, die Teamkultur zu stärken.',
    backToHome: 'Zurück zur Startseite',
    greetingMorning: 'Guten Morgen',
    greetingAfternoon: 'Guten Tag',
    greetingEvening: 'Guten Abend',
    pendingCountPre: 'Sie haben',
    pendingCountSingular: 'ausstehende Umfrage',
    pendingCountPlural: 'ausstehende Umfragen',
    allDoneTitle: 'Alles erledigt!',
    allDoneSubtitle: 'Sie haben keine ausstehenden Umfragen. Sie erscheinen hier nach Ihrem nächsten Meeting.',
    omit: 'Überspringen',
    omitSurvey: 'Umfrage überspringen',
    submitSuccess: 'Antworten gesendet',
    submitError: 'Fehler beim Senden — bitte erneut versuchen',
    omitSuccess: 'Umfrage übersprungen',
    omitError: 'Fehler — bitte erneut versuchen',
    kpi: {
      answered: 'Beantwortet',
      omitted: 'Übersprungen',
      streak: 'Serie',
      participation: 'Beteiligung',
    },
    growth: {
      title: 'Ihr Wachstum wartet auf Sie',
      message: 'Überprüfen Sie Ihre Ergebnisse, Trends und Entwicklungsbereiche im Wachstums-Dashboard.',
      cta: 'Mein Wachstum ansehen',
    },
    tips: {
      title: 'Tipps für Sie',
      based: 'Basierend auf Ihrem Durchschnittsscore',
      empty: 'Schließen Sie mehr Umfragen ab, um personalisierte Tipps zu sehen',
      reconocer: 'Zum Anerkennen',
      crecer: 'Zum Wachsen',
      tipOfDay: 'Tipp des Tages',
    },
  },
  safe: {
    title: 'Mein Wachstum',
    subtitle: 'Ihre kulturelle Entwicklung bei Sigma',
    sectionName: 'Mein Feedback',
    surveysAnswered: 'Beantwortete Umfragen',
    score: 'Ihr Score',
    evolution: 'Ihre Entwicklung',
    evolutionSub: 'Ihre persönliche Reise — nur Sie, ohne Vergleiche',
    radarTitle: 'Ihr Profil nach Grundwert',
    radarSub: 'Sie heute vs Sie vor 3 Monaten',
    fundamentals: 'Grundwerte',
    fundamentalsChart: 'Ihr Feedback nach Grundwert',
    fundamentalsChartSub: 'Wo Sie bei jedem stehen — klicken Sie auf einen Balken für Details',
    behaviors: 'Verhaltensweisen',
    kudos: 'Anerkennungen',
    kudosTitle: 'Zum Anerkennen — was Sie am meisten einbringen',
    kudosSub: 'Was Ihre Kollegen diesen Monat am meisten an Ihnen beobachten',
    actions: 'Aktionsplan',
    omissions: 'Auslassungen',
    period: 'Zeitraum',
    received: 'Empfangen',
    sent: 'Gesendet',
    areaAverage: 'Bereichsdurchschnitt',
    today: 'Heute (Jan 2026)',
    threeMonthsAgo: 'Vor 3 Monaten (Okt 2025)',
    detail: 'Detail',
    profileTitle: 'Ihr kulturelles Profil in Worten',
    profileSub: 'Verhaltensweisen, keine Zahlen',
    basedOn: 'Basiert auf {{count}} anonymen Feedbacks',
    level0: 'Anfänger',
    level1: 'In Entwicklung',
    level2: 'Konsistent',
    level3: 'Vorbild',
    level0desc: 'Wartet darauf, dass andere Probleme lösen oder Hindernisse beseitigen.',
    level1desc: 'Versucht Hindernisse anzugehen, gibt aber schnell auf oder eskaliert zu früh.',
    level2desc: 'Ergreift die Initiative, um Hindernisse zu beseitigen und Lösungen zu finden, die Fortschritte ermöglichen.',
    level3desc: 'Inspiriert andere, die Initiative zu ergreifen, und schafft ein Umfeld, in dem das Überwinden von Blockaden eine gemeinsame Verantwortung ist.',
    levelAbbr0: 'Anfang',
    levelAbbr1: 'In Entw.',
    levelAbbr2: 'Konsist.',
    levelAbbr3: 'Vorbild',
    todayLabel: 'Heute',
    pointsInMonths: 'Punkte in {{n}} Monaten',
    monthsWithFeedback: 'Monate mit Feedback',
    thisMonth: 'diesen Monat',
    headingToLevel: 'Auf dem Weg zu {{level}}',
    maxLevel: 'Höchstes Level!',
    narrativeStrength: 'Was du am meisten beiträgst und Anerkennung verdient ist <strong>{{fund}}</strong> — du befindest dich auf Stufe <strong>{{level}}</strong>.',
    narrativeConsistency: 'Du zeigst auch Beständigkeit in {{others}}.',
    narrativeProgress: 'In den letzten 3 Monaten hast du Fortschritte gemacht — dein Profil zeigt Wachstum.',
    narrativeStable: 'Dein Profil ist in den letzten 3 Monaten stabil geblieben — das spricht für Beständigkeit.',
    narrativeVariation: 'Dein Profil hat in den letzten Monaten leicht variiert. Schwankungen sind normal und definieren dich nicht.',
    narrativeNextLevel: 'Dein nächstes Wachstumslevel liegt in <strong>{{fund}}</strong>. Der nächste Schritt ist, Level {{level}} zu erreichen — unten schlagen wir eine konkrete Aktion vor.',
    act01: 'Anerkennung — wie andere Sie sehen',
    act02: 'Fortschritt — wie Sie sich entwickelt haben',
    act03: 'Richtung — Ihr nächster Schritt',
    reinforces: 'STÄRKT',
    tryToday: 'Ich probiere es heute',
    committed: 'Ich verpflichte mich heute!',
    defaultChallenge: 'Üben Sie heute einen Grundwert',
    defaultChallengeDesc: 'Wählen Sie eine Micro-Aktion und setzen Sie sie in Ihrem nächsten Meeting um.',
    clickDetail: 'Klick für Details',
    nextLevel: 'NÄCHSTE STUFE',
    growthTitle: 'UM WEITER ZU WACHSEN',
    growthSub: 'Empfehlungen basierend auf Ihrem Feedback',
    feedbacks: 'Feedbacks',
    peers: 'Kollegen',
    givenTitle: 'Meine Teilnahme beim Geben von Feedback',
    givenSub: 'Feedback das Sie diesen Monat geteilt haben',
    footerPrivacy: 'Alles Feedback ist anonym. Niemand kann sehen wer es Ihnen gegeben hat.',
    footerHeart: 'Denken Sie daran: Feedback ist ein Geschenk. Diese Daten spiegeln Momente in Meetings wider.',
    personSingular: 'Person',
    personsPlural: 'Personen',
    trend: {
      up: 'Ihr Profil zeigt Wachstum',
      down: 'Kleine Variation — das ist normal',
      stable: 'Stabiles Profil — das ist Konsistenz',
    },
    empty: {
      title: 'Lerne die Fundamentals kennen',
      desc: 'Du hast noch nicht genügend Feedback, um dein Dashboard anzuzeigen. Erkunde in der Zwischenzeit die Verhaltensweisen, die wir messen.',
      hint: 'Du benötigst mindestens 3 Bewertungen, um dein persönliches Dashboard zu aktivieren. Nimm an den Umfragen nach dem Meeting teil, um Feedback zu erhalten.',
    },
    popup: {
      peersOpined: 'Kollegen haben bewertet',
      subbehaviors: 'Teilverhalten',
      monthlyHistory: 'Monatliche Entwicklung',
      distribution: 'Feedback-Verteilung',
      behaviorScale: 'Verhaltensskala',
      you: 'Sie',
    },
  },
  admin: {
    title: 'Verwaltung',
    panelTitle: 'Admin-Panel',
    roleAdminCentral: 'Zentral-Admin',
    roleAdminOU: 'OE-Admin',
    roleEmployee: 'Mitarbeiter',
    greetingMorning: 'Guten Morgen',
    greetingAfternoon: 'Guten Tag',
    greetingEvening: 'Guten Abend',
    surveys: 'Umfragen',
    templates: 'Vorlagen',
    analyticsTab: 'Analytik',
    rulesTab: 'Geschäftsregeln',
    users: 'Benutzer',
    notifications: 'Benachrichtigungen',
    surveysTitle: 'Umfragenverwaltung',
    searchSurvey: 'Umfrage suchen...',
    trash: 'Papierkorb',
    newSurvey: 'Neue Umfrage',
    fundamentalsTab: 'Allgemein',
    customTab: 'Benutzerdefiniert',
    colName: 'Name',
    colTitle: 'Titel',
    colDescription: 'Beschreibung',
    colQuestions: 'Fragen',
    colStatus: 'Status',
    colAudience: 'Zielgruppe',
    colFrequency: 'Häufigkeit',
    colFeedback: 'Rückmeldungen',
    colPeriod: 'Zeitraum',
    colActions: 'Aktionen',
    colCreatedBy: 'Erstellt von',
    colEmail: 'E-Mail',
    colOU: 'OE',
    colUses: 'Nutzungen',
    statusActive: 'Aktiv',
    statusPaused: 'Pausiert',
    statusInactive: 'Inaktiv',
    statusPending: 'Ausstehend',
    anonymous: 'Anonym',
    duplicate: 'Duplizieren',
    exportExcelTip: 'Excel exportieren',
    templatesTitle: 'Umfragevorlagen',
    tipsTab: 'Tipps',
    actionsTab: 'Aktionen',
    catalogTab: 'Kataloge',
    createTemplate: 'Vorlage erstellen',
    typeFundamental: 'Grundwert',
    typeCustom: 'Benutzerdefiniert',
    placeholderTips: 'Tipps — Ratgebermodul für Mitarbeiter',
    tplSearchPlaceholder: 'Template suchen…',
    tplFilterAll: 'Alle Typen',
    tplNoResults: 'Keine Templates gefunden',
    tipsTitle: 'Feedback-Tipps',
    tipsSearchPlaceholder: 'Tipp suchen…',
    tipsAllFundamentals: 'Alle Grundwerte',
    tipsAllTypes: 'Alle Typen',
    tipTypeReconocer: 'Zum Anerkennen',
    tipTypeCrecer: 'Zum Wachsen',
    tipsNoResults: 'Keine Tipps gefunden',
    surveysNoResults: 'Keine Umfragen mit diesem Kriterium',
    surveysError: 'Fehler beim Laden der Umfragen. Bitte versuchen Sie es später erneut.',
    createTip: 'Tipp erstellen',
    actionsTitle: 'Wachstumsmaßnahmen',
    actionsSearchPlaceholder: 'Maßnahme suchen…',
    actionsNoResults: 'Keine Maßnahmen gefunden',
    createAction: 'Maßnahme erstellen',
    catalogTitle: 'Grundwerte-Katalog',
    catalogFundamentals: 'Grundwerte',
    catalogBehaviors: 'Verhaltensweisen',
    catalogAddFundamental: 'Grundwert hinzufügen',
    catalogAddBehavior: 'Daily Habit hinzufügen',
    catalogSearchFundamental: 'Grundwert suchen…',
    catalogSearchBehavior: 'Daily Habit suchen…',
    catalogNoBehaviors: 'Keine Daily Habits für diesen Grundwert',
    catalogSelectFundamental: 'Wählen Sie einen Grundwert aus der Liste',
    ousTab: 'OEs',
    ousTitle: 'Organisationseinheiten',
    ousSubtitle: 'Root-OEs des Tenants verwalten',
    ousSearchPlaceholder: 'OE suchen…',
    ousNoResults: 'Keine OE entspricht dem Kriterium',
    createOU: 'OE erstellen',
    editOU: 'OE bearbeiten',
    deleteOU: 'OE löschen',
    deleteOUConfirm: 'OE "{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    ouDescription: 'Beschreibung',
    ouAdminUser: 'OE-Admin (AAD User ID)',
    ouType: 'Typ',
    ouGdpr: 'DSGVO',
    ouAzureGroupId: 'Azure AD-Gruppen-ID',
    ouAzureGroupIdHint: 'Verknüpfen Sie diese OE mit ihrer echten Azure AD-Gruppe für die Hierarchieansicht. Leer lassen, wenn noch nicht bereitgestellt.',
    ouAzureGroupIdSelectPlaceholder: '— Azure AD-Stammgruppe auswählen —',
    ouAzureGroupIdLoading: 'Azure AD-Gruppen werden geladen…',
    ouAzureGroupIdRootsError: 'Die Liste der Azure AD-Gruppen konnte nicht geladen werden. Sie können die ID manuell eingeben.',
    ouAzureGroupIdCurrentUnknown: 'Aktuell verknüpfte Gruppe (nicht in der Liste)',
    ouAzureGroupIdManualToggle: 'ID manuell eingeben',
    ouAzureGroupIdListToggle: 'Aus der Liste wählen',
    ouActivate: 'OE aktivieren',
    ouDeactivate: 'OE deaktivieren',
    ouExpand: 'Erweitern',
    ouCollapse: 'Einklappen',
    ouSelectPlaceholder: 'OU auswählen…',
    ouErrorName: 'Der OE-Name ist erforderlich',
    ouTimezone: 'Zeitzone',
    ouTimezoneSelect: 'Zeitzone auswählen',
    ouErrorTimezone: 'Zeitzone ist erforderlich',
    colFundamental: 'Grundwert',
    colCondition: 'Bedingung',
    placeholderActions: 'Aktionen — Aktionspläne nach Umfragen',
    placeholderCatalog: 'Grundwerte-Katalog — Bibliothek bewertbarer Verhaltensweisen',
    placeholderAnalytics: 'Einheitliches Analyse-Dashboard — Führungsansicht für vollständige Details',
    activeUsersLabel: 'Aktive Mitarbeiter',
    avgCulturalScore: 'Durchschnittlicher Kulturscore',
    participationRateLabel: 'Teilnahmequote',
    omissionRateLabel: 'Auslassungsquote',
    thisMonth: 'diesen Monat',
    rulesTitle: 'Geschäftsregeln',
    restoreDefaults: 'Standards wiederherstellen',
    restoreDefaultsTitle: 'Standardkonfiguration wiederherstellen',
    restoreDefaultsDesc: 'Alle Werte der Geschäftsregeln werden auf ihre ursprüngliche Konfiguration zurückgesetzt. Diese Aktion kann nicht rückgängig gemacht werden.',
    restoreDefaultsConfirm: 'Ja, wiederherstellen',
    rn001Title: 'Besprechungskriterien',
    rn001Subtitle: 'Legt die Besprechungsdauer fest, die eine Umfrage auslöst',
    rn002Title: 'Ausschlussregeln',
    rn002Subtitle: 'Szenarien, bei denen KEINE Umfragen ausgelöst werden',
    rn004Title: 'Benutzerlimits',
    rn004Subtitle: 'Steuert die Anzahl der Umfragen, die jede Person erhält',
    rn005Title: 'Tägliches Umfragenlimit',
    rn005Subtitle: 'Maximale Anzahl von Umfragen, die ein Benutzer pro Tag erhalten kann',
    fieldMinSessionDuration: 'Mindestdauer der Sitzung',
    fieldMaxSessionDuration: 'Maximaldauer der Sitzung',
    fieldMinParticipants: 'Mindestteilnehmer',
    fieldMaxParticipants: 'Maximalteilnehmer',
    fieldExclRecurring: 'Wiederkehrende Besprechungen ausschließen',
    fieldExclRecurringSub: 'Nicht auf wöchentliche Meetings, Dailies usw. anwenden',
    fieldExclWorkHours: 'Außerhalb der Arbeitszeiten ausschließen',
    fieldExclWorkHoursSub: 'Nur innerhalb der je OE konfigurierten Zeiten anwenden',
    fieldMaxSurveysWeek: 'Maximale Umfragen pro Woche',
    fieldMaxParticipantsPerSurvey: 'Maximale zu bewertende Teilnehmer pro Umfrage',
    fieldMinInterval: 'Mindestintervall zwischen Umfragen',
    fieldMaxSurveysDay: 'Maximale Umfragen pro Tag pro Benutzer',
    rn005Info: 'Wenn ein Benutzer bereits die maximale Anzahl an Umfragen für den Tag erhalten hat, werden die folgenden auf den nächsten Werktag verschoben und dabei die konfigurierte Prioritätsreihenfolge eingehalten.',
    suffixMinutes: 'Minuten',
    suffixUsers: 'Benutzer',
    suffixSurveysWeek: 'Umfragen/Woche',
    suffixPersons: 'Personen',
    suffixHours: 'Stunden',
    suffixSurveysDay: 'Umfragen / Tag',
    customizableByOU: 'Anpassbar pro OE',
    cancelChanges: 'Änderungen abbrechen',
    saveConfig: 'Konfiguration speichern',
    rulesConfig: 'Konfiguration',
    rulesStatus: 'Status',
    rulesCustom: 'Benutzerdefiniert',
    rulesSave: 'Speichern',
    rulesCancel: 'Abbrechen',
    rulesSchedule: 'Zeitplan',
    rulesInheritsGlobal: '↑ Erbt global',
    rulesInherited: 'Geerbt',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Anpassen',
    tplCatAll: 'Alle',
    tplCatGeneral: 'Allgemein',
    tplCatCustom: 'Benutzerdefiniert',
    usersTitle: 'Benutzerverwaltung',
    searchUser: 'Benutzer suchen...',
    newUser: 'Neuer Benutzer',
    notificationsTitle: 'Benachrichtigungseinstellungen',
    notifOmitirTitle: 'Übersprungen-Benachrichtigung',
    notifyAfter: 'Benachrichtigen nach',
    consecutiveOmissions: 'aufeinanderfolgenden Überspringungen',
    notifyTo: 'Benachrichtigen:',
    notifyUser: 'Benutzer',
    notifyDirectManager: 'Direkter Vorgesetzter',
    notifyAdminOU: 'OE-Administrator',
    messageForUser: 'Nachricht für den Benutzer:',
    availableVarsOmitir: 'Verfügbare Variablen: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Europa-Auslassungen (BU)',
    manualOnlyGDPR: 'Nur manuell — DSGVO',
    gdprWarning: 'Aufgrund gesetzlicher Vorschriften (DSGVO) werden Auslassungs-E-Mails für Europa niemals automatisch gesendet. Der Administrator muss sie manuell verfassen, überprüfen und senden.',
    emailTemplateEmployee: 'E-Mail-Vorlage — Europa-Mitarbeiter:',
    reviewBeforeSending: 'Vor jedem Versand überprüfen und anpassen.',
    generalNotificationsTitle: 'Allgemeine Benachrichtigungen',
    notifMessageLabel: 'Benachrichtigungsnachricht:',
    notifMessagePlaceholder: 'Schreiben Sie die Nachricht, die Sie den Mitarbeitern senden möchten...',
    notifAudienceLabel: 'Zielgruppe:',
    notifAudienceGlobal: 'Global (ohne Europa)',
    sendNotification: 'Benachrichtigung senden',
    availableVarsGeneral: 'Verfügbare Variablen: {nombre}, {ou}, {fecha}',
    saveChanges: 'Änderungen speichern',
    saveTemplates: 'Vorlagen speichern',
    sidebarExpand: 'Menü erweitern',
    sidebarCollapse: 'Menü einklappen',
    analyticsComingSoon: 'Analytics-Dashboard — in Entwicklung. Siehe Executive-Ansicht für vollständige Details.',
    colType: 'Typ',
    tplCategory: 'Kategorie',
    tplQuestions: 'Fragen',
    tplUse: 'Verwenden',
    tplDeleteTitle: 'Vorlage löschen',
    tplDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    tipDeleteTitle: 'Tipp löschen',
    tipDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    tipEditTitle: 'Tipp bearbeiten',
    tipAddTitle: 'Tipp hinzufügen',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Wählen Sie ein Fundamental…',
    tipFormDailyHabit: 'Verknüpfte Daily Habit',
    tipFormSelectDailyHabit: 'Wählen Sie eine Daily Habit…',
    tipFormOperator: 'Operator',
    tipFormThreshold: 'Schwellenwert %',
    tipFormMax: 'Max %',
    tipFormType: 'Tipp-Typ',
    tipFormName: 'Tipp-Name',
    tipFormNamePlaceholder: 'Z.B. Herausragendes Lernen',
    tipFormText: 'Tipp-Text',
    tipFormTextPlaceholder: 'Nachricht, die der Mitarbeiter sehen wird…',
    tipFormActivationRule: 'Ergebnisbedingung',
    tipFormActive: 'Aktiv',
    tipFormPreview: 'Vorschau',
    tipRangeMin: 'Mindestgrenze',
    tipRangeMax: 'Höchstgrenze',
    tipHintCondition: 'Durchschnittlicher Score des Fundamentals (0–100). Bsp: 0 bis 40 aktiviert den Tipp bei niedrigen Ergebnissen.',
    tipHintBehavior: 'Spezifisches Verhalten, auf das dieser Tipp zutrifft.',
    tipFieldObserved: 'Beobachteter Text',
    tipTagGreen: 'helle grüne Box',
    tipTagDark: 'dunkle Box',
    tipTagBlue: 'Nächste Stufe-Box',
    tipHintObserved: 'Was Kollegen am häufigsten beobachten. Erscheint kursiv im Leistungspanel.',
    tipFieldGrowthSuggestion: 'Wachstumsempfehlung',
    tipHintGrowthSuggestion: 'Umsetzbare Empfehlung, die neben der Anerkennung erscheint.',
    tipFieldLevelName: 'Stufenname',
    tipLevelNamePlaceholder: 'Bsp. Nötiger Impuls, Im Aufbau…',
    tipCrecerPairedPlaceholder: 'Bsp. Erwähnen Sie den Verbraucher: Fragen Sie bei Ihrer nächsten Entscheidung…',
    tipTranslations: 'Übersetzungen',
    tipAddLang: '+ Hinzufügen:',
    tipPreviewContext: 'So erscheint es im Dashboard des Mitarbeiters:',
    tipSave: 'Tipp speichern',
    tipSaveError: 'Zum Speichern folgende Felder ausfüllen:',
    colContent: 'Inhalt',
    colActive: 'Aktiv',
    opGte: 'größer oder gleich',
    opLte: 'kleiner oder gleich',
    opGt: 'größer als',
    opLt: 'kleiner als',
    opBetween: 'Zwischen (Bereich)',
    actionEditTitle: 'Aktion bearbeiten',
    actionNewTitle: 'Neue Aktion',
    actionFormTitle: 'Aktionstitel',
    actionFormTitlePlaceholder: 'Z.B. Schlagen Sie eine konkrete Aktion vor',
    actionFormDescription: 'Vollständige Beschreibung',
    actionFormDescPlaceholder: 'Beschreibung der Aktion…',
    actionActivationRule: 'Aktivierungsregel',
    actionActivationRuleHint: 'Durchschnittlicher Fundamental-Score (1–4). Definiert den Bereich, der diese Aktion auslöst.',
    actionRuleMin: 'Mindestschwelle',
    actionRuleMax: 'Höchstschwelle',
    actionRangeLabel: 'Bereich',
    actionNextLevelText: '"Nächste Stufe"-Text',
    actionNextLevelHint: 'Wird im blauen Kasten der Karte angezeigt.',
    actionNextLevelPlaceholder: 'Z.B. Um die nächste Stufe zu erreichen, konzentriere dich auf…',
    actionPreview: 'Vorschau',
    actionPreviewEmpty: 'Fülle das Formular aus, um die Vorschau zu sehen',
    actionTranslations: 'Übersetzungen',
    actionTransComplete: 'Übersetzung vollständig',
    actionTransMissing: 'Übersetzung unvollständig',
    actionPreviewContext: 'So wird es im Dashboard des Mitarbeiters angezeigt:',
    actionFormDescHint: 'Wird beim Öffnen der Aktion angezeigt.',
    actionSave: 'Aktion speichern',
    actionSaveError: 'Zum Speichern, bitte folgende Felder ausfüllen:',
    actionDeleteTitle: 'Aktion löschen',
    actionDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    fundEditTitle: 'Fundamental bearbeiten',
    fundNewTitle: 'Neues Fundamental',
    fundFormFullName: 'Vollständiger Name',
    fundFormFullNamePlaceholder: 'Z.B. Mindset & Behavior - Learner',
    fundFormShortName: 'Kurzname',
    fundFormShortNamePlaceholder: 'Z.B. Learner',
    fundFormDescription: 'Beschreibung',
    fundFormDescriptionPlaceholder: 'Kurze Beschreibung dieses Fundamentals...',
    fundFormIcon: 'Symbol',
    fundFormColor: 'Farbe',
    fundFormUrl: 'Referenz-URL',
    fundFormUrlPlaceholder: 'https://...',
    fundFormLanguage: 'Sprache',
    fundFormAllLangsRequired: 'Füllen Sie den vollständigen Namen, Kurznamen und die Beschreibung in allen 7 Sprachen aus, um zu speichern.',
    behEditTitle: 'Daily Habit bearbeiten',
    behNewTitle: 'Neues Daily Habit',
    behFormName: 'Daily Habit Name',
    behFormNamePlaceholder: 'Z.B. Humility & Openness',
    behFormAllLangsRequired: 'Füllen Sie den Namen in allen 7 Sprachen aus, um zu speichern.',
    behFormFundamental: 'Verknüpftes Fundamental',
    behFormIntro: 'Einleitung / Bewertungskontext',
    behFormIntroPlaceholder: 'Z.B. In diesem Meeting hat diese Person…',
    behFormRoles: 'Anwendbare Rollen',
    behFormRolesHint: 'Für wen gilt diese Daily Habit?',
    fundDeleteTitle: 'Fundamental löschen',
    fundDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    behDeleteTitle: 'Daily Habit löschen',
    behDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    imageUploadSelect: 'Bild hochladen',
    imageUploadChange: 'Bild ändern',
    imageUploadInvalidFormat: 'Nicht unterstütztes Format. Verwende PNG, JPG, WEBP oder SVG.',
    imageUploadTooLarge: 'Die Datei überschreitet die maximal zulässige Größe (2 MB).',
    fundFormImage: 'Bild',
    attNewTitle: 'Neue Haltung und Verhalten',
    attEditTitle: 'Haltung und Verhalten bearbeiten',
    attFormName: 'Name der Haltung und Verhalten',
    attFormNamePlaceholder: 'Z. B. Aktive Zusammenarbeit',
    attFormDescription: 'Beschreibung der Haltung und des Verhaltens',
    attFormDescriptionPlaceholder: 'Kurze Beschreibung dieser Haltung und dieses Verhaltens...',
    attFormAllLangsRequired: 'Fülle den Namen in allen 7 Sprachen aus, um zu speichern.',
    attFormImage: 'Bild',
    attDeleteTitle: 'Haltung und Verhalten löschen',
    attDeleteDesc: '"{{name}}" löschen? Die zugehörigen Daily Habits werden ebenfalls deaktiviert.',
    catalogAttitudesLabel: 'Haltungen und Verhalten',
    catalogSelectAttitude: 'Wähle eine Haltung und Verhalten aus der Liste',
    catalogBackToFundamentals: 'Zurück zu Fundamentals',
    catalogBackToAttitudes: 'Zurück zu Haltungen und Verhalten',
    catalogGroupWithAttitudes: 'Unter Haltungen und Verhalten gruppieren',
    catalogNoFundamentals: 'Keine Fundamentals',
    madurezEditTitle: 'Kulturelle Reifestufen bearbeiten',
    madurezFrameworkTitle: 'Kulturelle Reife — Stufenrahmen',
    nivelesAdopcionTitle: 'Adoptionsstufen eines Daily Habits — Stufenrahmen',
    nivelesAdopcionEditTitle: 'Adoptionsstufen eines Daily Habits bearbeiten',
    madurezLabelPlaceholder: 'Bezeichnung',
    audienceGlobal: 'Global (ohne Europa)',
    audienceMexico: 'Mexiko',
    audienceLATAM: 'LATAM',
    audienceUSA: 'USA',
    audienceFOSE: 'FOSE',
    rn000Title: 'App pro OE deaktivieren',
    rn000Subtitle: 'Schaltet Sigma Pulse für eine oder mehrere Organisationseinheiten vollständig ab.',
    rn000Warning: 'Beim Deaktivieren einer OE erhalten alle Mitarbeiter sofort keine Umfragen mehr. Historische Daten werden aufbewahrt.',
    rn003Title: 'Arbeitszeiten pro OE',
    rn003Subtitle: 'Zeiten, in denen Umfragen angewendet werden (Ortszeit)',
    rn003GlobalDefault: 'Globale Standardzeiten',
    rn003GlobalNote: 'Gilt für alle OEs ohne eigene Zeiteinstellung.',
    rn003TimeConnector: 'bis',
    ouActive: 'Aktiv',
    ouDisabled: 'Deaktiviert',
    rn002KwLabel: 'Nur ausschließen, wenn der Name enthält:',
    rn002KwHint: '(leer = alle wiederkehrenden)',
    rn002KwPlaceholder: 'Stichwort hinzufügen...',
    usersAdminTitle: 'Administratorenverwaltung',
    addAdmin: 'Administrator hinzufügen',
    editAdmin: 'Administrator bearbeiten',
    newAdmin: 'Neuer Administrator',
    adminEmail: 'E-Mail-Adresse',
    adminEmailInvalid: 'Geben Sie eine gültige E-Mail-Adresse ein (z.B. name@domain.com)',
    adminRole: 'Rolle',
    adminRolePlaceholder: 'Rolle auswählen...',
    adminOU: 'Organisationseinheit (OE)',
    adminOUPlaceholder: 'OE auswählen...',
    adminOUAll: 'Alle (vollständiger OE-Zugriff)',
    adminBU: 'Geschäftseinheit (BU) — optional',
    adminBUPlaceholder: 'Gesamte OE (keine Einschränkung)',
    adminBUHint: 'Ohne BU-Auswahl verwaltet der Admin die gesamte OE.',
    colUser: 'Benutzer',
    colAlcance: 'Geltungsbereich',
    colPermisos: 'Berechtigungen',
    colEstado: 'Status',
    permGlobalTitle: 'OE/BU-Admins können Umfragen erstellen',
    permGlobalDesc: 'Wenn aktiv, können alle OE/BU-Admins Umfragen erstellen und senden.',
    permEnabled: 'Aktiviert',
    permDisabled: 'Deaktiviert',
    permCreateSurveys: 'Umfragen erstellen',
    permViewAnalytics: 'Analytics anzeigen',
    permManageUsers: 'Benutzer verwalten',
    permApproveSurveys: 'Umfragen genehmigen',
    userDeleteTitle: 'Administrator löschen',
    userDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    noUsersFound: 'Keine Ergebnisse',
    adminCount: 'Administratoren',
    messageForManager: 'Nachricht für den Manager:',
    emailTemplateManager: 'E-Mail-Vorlage — Europa-Manager:',
    notifOUPersonalization: 'Personalisierung pro OE',
    addOUPersonalization: 'Personalisierung hinzufügen',
    europaNoAutoSend: 'Diese E-Mails werden nicht automatisch gesendet. Sie müssen manuell gesendet werden.',
    europaActivateTitle: 'Europa-Benachrichtigungen aktivieren?',
    europaActivateDesc: 'Benachrichtigungen über Auslassungen für Europa unterliegen strengen DSGVO-Vorschriften. Durch die Aktivierung dieses Abschnitts bestätigen Sie, dass Sie die Genehmigung des Datenschutzbeauftragten der OE Europa haben und dass E-Mails manuell mit vorheriger Prüfung gesendet werden.',
    europaActivateConfirm: 'Ja, verantwortungsvoll aktivieren',
    includeEuropa: 'Europa (BU) einbeziehen',
    includeEuropaHint: 'erfordert DSGVO-Prüfung vor dem Senden',
    europaSectionDisabled: 'Abschnitt deaktiviert — Schalter aktivieren zum Konfigurieren',
    ouPersonalizedSingular: 'personalisierte OU',
    ouPersonalizedPlural: 'personalisierte OUs',
    notifCustomUserMsgPlaceholder: 'Benutzerdefinierte Nachricht für den Benutzer…',
    notifCustomMgrMsgPlaceholder: 'Benutzerdefinierte Nachricht für den Manager…',
    kwRemove: 'Entfernen',
    kwAdd: 'Hinzufügen',
    permissions: 'Berechtigungen',
    rules: 'Geschäftsregeln',
    catalog: 'Katalog',
    createUser: 'Benutzer erstellen',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer löschen',
    roles: 'Rolle',
    organizationalUnit: 'Organisationseinheit',
    minDuration: 'Mindestdauer (min)',
    maxDuration: 'Maximaldauer (min)',
    minParticipants: 'Mindestteilnehmer',
    maxPerDay: 'Max. Bewertungen pro Tag',
    maxPerWeek: 'Max. Bewertungen pro Woche',
    omissionThreshold: 'Auslassungsschwelle',
    columns: 'Spalten',
    colPickerTitle: 'Sichtbare Spalten',
    colPickerReset: 'Zurücksetzen',
    pagerRowsPerPage: 'Zeilen pro Seite',
    pagerOf: 'von',
    confirmMoveToTrash: 'In den Papierkorb verschieben?',
    confirmMoveToTrashMsg: 'Die Umfrage wird in den Papierkorb verschoben und nach 30 Tagen endgültig gelöscht. Sie können sie vorher wiederherstellen.',
    confirmMoveBtn: 'In den Papierkorb',
    confirmDeleteForeverTitle: 'Endgültig löschen?',
    confirmDeleteForeverMsg: 'Diese Aktion ist unumkehrbar. Die Umfrage und alle ihre Daten werden dauerhaft gelöscht.',
    confirmDeleteForeverBtn: 'Endgültig löschen',
    trashTitle: 'Papierkorb',
    trashSubtitle: 'Umfragen werden nach 30 Tagen endgültig gelöscht',
    trashEmpty: 'Der Papierkorb ist leer',
    trashRestore: 'Wiederherstellen',
    trashDaysLeft: 'Tage übrig',
    colSurvey: 'Umfrage',
    trashResponses: 'Antw.',
    trashTimeLeft: 'Verbleibende Zeit',
    trashDeletedBy: 'Gelöscht von',
    trashDeletedAt: 'Löschdatum',
    trashDays: 'Tage',
    trashExpiresTODAY: 'Läuft heute ab',
    filterAll: 'Alle',
    filterSearchName: 'Name suchen…',
    filterSearchCreator: 'Ersteller suchen…',
    filterFrom: 'Von',
    filterTo: 'Bis',
    filterClearDates: 'Daten löschen',
    pauseSurvey: 'Pausieren',
    activateSurvey: 'Aktivieren',
    builderNewTitle: 'Neue Umfrage',
    builderEditTitle: 'Umfrage bearbeiten',
    builderNewTemplateTitle: 'Neue Vorlage',
    builderEditTemplateTitle: 'Vorlage bearbeiten',
    builderBackToSurveys: 'Zurück zu Umfragen',
    builderSaveDraft: 'Entwurf speichern',
    builderPublish: 'Umfrage veröffentlichen',
    builderStep1: 'Grundinformationen',
    builderStep2: 'Zielgruppe und Häufigkeit',
    builderStep3: 'Fragen',
    builderStep4: 'Überprüfung',
    builderPreview: 'Vorschau',
    builderName: 'Name der Umfrage',
    builderNamePlaceholder: 'Bsp: Post-Meeting-Bewertung Q2',
    builderDescription: 'Beschreibung',
    builderDescriptionPlaceholder: 'Beschreiben Sie den Zweck dieser Umfrage…',
    builderApproach: 'Ansatz',
    builderApproachIndividual: 'Individuell',
    builderApproachCollective: 'Kollektiv',
    builderAnonymous: 'Anonyme Bewertung',
    builderAnonymousSub: 'Die Beurteilten wissen nicht, wer sie bewertet hat',
    dayMon: 'Montag', dayTue: 'Dienstag', dayWed: 'Mittwoch', dayThu: 'Donnerstag',
    dayFri: 'Freitag', daySat: 'Samstag', daySun: 'Sonntag',
    dayMonShort: 'Mo', dayTueShort: 'Di', dayWedShort: 'Mi', dayThuShort: 'Do',
    dayFriShort: 'Fr', daySatShort: 'Sa', daySunShort: 'So',
    dayLetterMon: 'M', dayLetterTue: 'D', dayLetterWed: 'M', dayLetterThu: 'D',
    dayLetterFri: 'F', dayLetterSat: 'S', dayLetterSun: 'S',
    activeDaysAll: 'Die Umfrage ist die ganze Woche aktiv',
    activeDaysPrefix: 'Die Umfrage ist aktiv an:',
    activeDaysNone: 'Kein Tag ausgewählt',
    workdays: 'Werktage',
    builderExitTitle: 'Editor verlassen?',
    builderExitDesc: 'Nicht gespeicherte Änderungen gehen verloren, wenn Sie jetzt verlassen.',
    builderExitCancel: 'Weiter bearbeiten',
    builderExitConfirm: 'Ja, verlassen',
    builderValidationTitle: 'Pflichtfelder',
    builderValidationDesc: 'Bitte füllen Sie die folgenden Felder aus, bevor Sie fortfahren:',
    builderValidationClose: 'Verstanden',
    builderValidationName: 'Interner Bezeichner',
    builderValidationSurveyType: 'Umfragetyp',
    builderValidationStartDate: 'Startdatum',
    builderValidationEndDate: 'Enddatum',
    builderValidationDateRange: 'Das Enddatum darf nicht vor dem Startdatum liegen',
    builderValidationActiveDays: 'Mindestens ein aktiver Tag',
    builderValidationMeetingId: 'Meeting-ID eingeben',
    builderValidationPeople: 'Mindestens eine Person auswählen',
    builderValidationOU: 'Mindestens eine OE auswählen',
    builderValidationNoQuestions: 'Sie müssen mindestens eine Frage hinzufügen, um fortzufahren. Umfragen können nicht ohne Fragen erstellt werden.',
    builderValidationMinParticipants: 'Die Mindestanzahl an Teilnehmern muss mindestens 1 betragen',
    builderValidationMaxParticipants: 'Die Höchstanzahl an Teilnehmern muss mindestens 1 betragen',
    builderValidationParticipantsRange: 'Die Mindestanzahl darf nicht größer als die Höchstanzahl sein',
    builderValidationTranslations: 'Unvollständige Übersetzungen',
    // Builder new keys
    builderCloseEditor: 'Editor schließen',
    builderPrevious: 'Zurück',
    builderNext: 'Weiter',
    builderSaveTemplate: 'Als Vorlage speichern',
    builderInternalId: 'Interner Bezeichner',
    builderInternalIdHint: 'Nur für Administratoren sichtbar — Mitarbeiter sehen diesen Namen beim Ausfüllen nicht',
    builderSurveyTypeStar: 'Umfragetyp',
    builderTypeGeneral: 'Allgemein',
    builderTypeGeneralDesc: 'Geregelt durch Geschäftsregeln. Wird automatisch nach Meetings ausgelöst.',
    builderTypePersonalized: 'Personalisiert',
    builderTypePersonalizedDesc: 'Verknüpft mit einer bestimmten Teams-Sitzung über Meeting-ID.',
    builderPeriod: 'Umfragezeitraum',
    builderStartLabel: 'Beginn',
    builderEndLabel: 'Ende',
    builderPeriodHint: 'Die Umfrage wird am Startdatum aktiviert und automatisch am Ende deaktiviert',
    builderActiveDaysLabel: 'Aktivierungstage',
    builderCustomTag: 'Benutzerdefiniert',
    builderAudienceSectionTitle: 'Zielgruppe',
    builderWhoApplies: 'Für wen gilt diese Umfrage?',
    builderSelectOneOrMoreOUs: 'Eine oder mehrere OE auswählen',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Alle OE und BU',
    builderExcludesEurope: 'ohne Europa',
    builderGlobalAdminOUAccess: 'Globaler Administrator — Sie haben Zugriff auf alle OEs im System.',
    builderLegalRegulation: 'Gesetzliche Vorschriften — immer ein separates Feld',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'DSGVO — Gesetzliche Vorschriften',
    builderEuropeExcludedNote: 'Europa ist aus rechtlichen Gründen nie in globalen oder Multi-OE-Kampagnen enthalten.',
    builderEuropaAuthNote: 'Denken Sie daran, die Genehmigung der OE Europa einzuholen, bevor Sie Umfragen an diese Region senden.',
    builderAudienceCustomTitle: 'Empfänger',
    builderAudienceCustomSubtitle: 'Definieren Sie, wer diese personalisierte Umfrage erhalten soll.',
    builderRecipientsLabel: 'Empfänger',
    builderByMeetingId: 'Per Meeting-ID',
    builderByPeople: 'Bestimmte Personen',
    builderByOU: 'Per Organigramm (OE)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'Personen',
    audienceTypeOU: 'OE',
    builderMeetingIdHint: 'Gilt für alle Teilnehmer dieser Teams-Sitzung',
    builderSelectPeople: 'Personen aus der Liste auswählen',
    builderAllOUs: 'Alle OE',
    builderAllAvailableAdded: 'Alle verfügbaren Personen wurden bereits hinzugefügt',
    builderSearchPeoplePlaceholder: 'Person nach Namen suchen…',
    builderLoadingPeople: 'Personen werden geladen…',
    builderErrorLoadingPeople: 'Die Personenliste konnte nicht geladen werden. Erneut versuchen.',
    builderPersonSelected: 'Person ausgewählt',
    builderPeopleSelected: 'Personen ausgewählt',
    builderSelectOU: 'OE auswählen...',
    builderSelectOUForTeam: 'Wählen Sie eine OE aus, um deren Mitarbeiter anzuzeigen',
    builderQuestionsTitle: 'Fragen',
    builderEuropaQuestionsNote: 'Europa-Modus: freie Umfrage, nicht mit Grundwerten verknüpft. Nur Fragen zur Besprechung.',
    builderQuestionsApplyToAll: 'Jede Frage gilt für jeden Besprechungsteilnehmer.',
    builderFilterAll: 'Alle',
    builderNoQuestions: 'Noch keine Fragen',
    builderNoQuestionsHint: 'Klicken Sie auf "+ Frage hinzufügen", um zu beginnen',
    builderNoQuestionsOfType: 'Keine Fragen dieses Typs',
    builderAddQuestion: '+ Frage hinzufügen',
    builderQuestionLabel: 'Frage',
    builderDeleteQuestion: 'Löschen',
    builderApproachLabel: 'Ansatz',
    builderIndividualSub: 'Bewertet jeden Teilnehmer',
    builderCollectiveSub: 'Für die Sitzung insgesamt',
    builderPresentationMode: 'Darstellungsmodus',
    builderMatrix: 'Allgemeine Matrix',
    builderMatrixSub: 'Frage zur Besprechung oder zum allgemeinen Thema',
    builderIndividualCard: 'Individuell',
    builderIndividualCardSub: 'Eine Karte pro Person',
    builderTypeLabel: 'Typ',
    builderFundamentalLabel: 'Grundwert',
    builderSelectFundamental: 'Grundwert auswählen...',
    builderDailyHabitLabel: 'Tägliche Gewohnheit',
    builderSelectDailyHabit: 'Tägliche Gewohnheit auswählen...',
    builderQuestionText: 'Fragetext',
    builderQuestionTextPlaceholder: 'Frage hier eingeben',
    builderIconLabel: 'Symbol',
    builderOptional: '(optional)',
    builderChangeIcon: 'Ändern',
    builderSelectIconBtn: 'Symbol auswählen',
    builderOptionsLabel: 'Optionen (max. 4 + "Nicht beobachtbar")',
    builderNoObservable: 'Nicht beobachtbar',
    builderRemoveNoObs: '"Nicht beobachtbar" entfernen',
    builderAddNoObs: '"Nicht beobachtbar" hinzufügen',
    builderAddOption: 'Option hinzufügen',
    builderMaxOptions: 'Maximal 4 Optionen erreicht',
    builderNPSInfo: 'NPS: Skala von 0 bis 10. Offene Frage, nicht den Teilnehmern zugewiesen.',
    builderOpenInfo: 'Freiraum für den Bewerter, seine Antwort zu schreiben.',
    builderCampaignWeight: 'Kampagnengewichtung',
    builderAdminGlobalOnly: 'Nur Global-Admin',
    builderCampaignWeightSub: 'Höhere Gewichtung = höhere Priorität, wenn mehrere Umfragen aktiv sind. Nur der Global-Admin kann dies ändern.',
    builderWeightBase: 'Basisgewichtung (1–10)',
    builderWeightVeryLow: 'Sehr niedrig',
    builderWeightLow: 'Niedrig',
    builderWeightMedium: 'Mittel',
    builderWeightHigh: 'Hoch',
    builderWeightVeryHigh: 'Sehr hoch',
    builderBoostUrgent: 'Dringender Boost',
    builderBoostUrgentSub: 'Hebt diese Umfrage vorübergehend über alle anderen',
    builderBoostDays: 'Tage',
    builderBoostActiveDays: 'Tag',
    builderBoostActiveMsg: 'Boost aktiv — diese Umfrage hat maximale Priorität für',
    builderNoBoostMsg: 'Kein aktiver Boost — Priorität gemäß Basisgewichtung',
    builderParticipantsTitle: 'Zu bewertende Teilnehmer',
    builderParticipantsSub: 'Definieren Sie, wie viele Personen pro Umfrage bewertet werden. Minimum für Anonymität und Maximum zur Vermeidung von Überlastung.',
    builderMinParticipantsLabel: 'Mindestteilnehmerzahl',
    builderMinParticipantsHint: 'Mind. zur Gewährleistung der Anonymität',
    builderMaxParticipantsLabel: 'Maximale Teilnehmerzahl',
    builderMaxParticipantsHint: 'Max. zu bewertende Personen pro Umfrage',
    builderPrivacyTitle: 'Datenschutz und Anonymität',
    builderPrivacySub: 'Definieren Sie, ob Feedback mit der Identität des Befragten verknüpft wird.',
    builderEnableAnonymity: 'Anonymität aktivieren',
    builderAnonymityDesc: 'Feedback enthält keinen Benutzernamen — nur Antwort und Uhrzeit',
    builderTranslationsTitle: 'Übersetzungen',
    builderTranslationsEuropeSub: 'Europa-Zielgruppe — alle 6 Sprachen erforderlich. Verwenden Sie den Schalter zum Aktivieren oder Deaktivieren einer Sprache.',
    builderTranslationsSub: 'Übersetzung ins Englische ist mindestens erforderlich. Verwenden Sie den Schalter, um weitere Sprachen zu aktivieren.',
    builderAutoTranslateNote: 'Übersetzungen werden automatisch mit Azure Translator generiert. Überprüfen und passen Sie jeden Bereich nach Bedarf an.',
    builderLangNotApplicable: 'Nicht anwendbar',
    builderLangComplete: 'Fertig',
    builderLangPending: 'Ausstehend',
    builderLangRequired: 'Erforderlich',
    builderAutoTranslateBtn: 'Auto-Übersetzen',
    builderLangApplies: 'Gilt',
    builderLangDoesNotApply: 'Gilt nicht',
    builderTrlName: 'Name:',
    builderTrlDesc: 'Beschreibung:',
    builderTrlEmpty: 'leer',
    builderLangDisabled: 'Diese Sprache ist für diese Umfrage deaktiviert.',
    builderReviewTitle: 'Überprüfen und veröffentlichen',
    builderReviewTemplateTitle: 'Vorlage überprüfen',
    builderEuropaPublishNote: 'Europa-Modus: unabhängige Kampagne wegen DSGVO. Denken Sie daran, die Genehmigung der OE Europa einzuholen.',
    builderPublishIdLabel: 'Bezeichner',
    builderPublishInternal: '(intern)',
    builderPublishTypeLabel: 'Typ',
    builderPublishAudienceLabel: 'Zielgruppe',
    builderPublishQuestionsLabel: 'Fragen',
    builderPublishActiveDaysLabel: 'Aktive Tage',
    builderPublishExpirationLabel: 'Ablauf',
    builderPublishAnonymityLabel: 'Anonymität',
    builderPublishAnonymousVal: 'Anonym',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Vor dem Veröffentlichen ausfüllen:',
    builderCompleteBeforeSave: 'Vor dem Speichern ausfüllen:',
    builderReadyToPublish: 'Alles bereit. Klicken Sie auf Umfrage veröffentlichen, um sie zu aktivieren.',
    builderReadyToSaveTemplate: 'Alles bereit. Klicken Sie auf Vorlage speichern, um sie zu speichern.',
    builderIconCatalogTitle: 'Symbolkatalog',
    builderSystemIcons: 'Systemsymbole',
    builderNoIcon: 'Kein Symbol',
    builderMyCatalog: 'Mein Katalog',
    builderDeleteFromCatalog: 'Aus Katalog löschen',
    builderCatalogEmpty: 'Ihr Katalog ist leer — laden Sie ein Symbol hoch und speichern Sie es hier',
    builderUploadIcon: 'Neues Symbol hochladen',
    builderIconNamePlaceholder: 'Symbolname (z.B. Innovation)',
    builderSelectFile: 'Datei auswählen',
    builderInvalidFormat: 'Ungültiges Format. Verwenden Sie SVG oder PNG mit transparentem Hintergrund.',
    builderFileTooLarge: 'Datei zu groß. Maximal 200 KB.',
    builderCustomIcon: 'Benutzerdefiniertes Symbol',
    builderSaveForReuse: 'Im Katalog zur Wiederverwendung speichern',
    builderUseIcon: 'Symbol verwenden',
    builderIconHelp: 'SVG oder PNG, transparenter Hintergrund, 512×512 px empfohlen, max. 200 KB',
    builderPreviewCompleteStep1: 'Füllen Sie die Daten in Schritt 1 aus, um die Vorschau zu sehen',
    builderPreviewClickToEdit: 'Klicken Sie auf einen beliebigen Text zum Bearbeiten',
    builderPreviewNoQuestions: 'Fragen erscheinen hier in Schritt 3',
    builderPreviewGeneral: 'Allgemein',
    builderPreviewPersonalized: 'Personalisiert',
    builderPreviewPulsoEspecifica: 'Spezifischer Puls',
    builderPreviewChangeIcon: 'Symbol ändern',
    builderPreviewIndividual: 'Individuell',
    builderPreviewCollective: 'Kollektiv',
    builderPreviewModeIndividual: 'Individuell',
    builderPreviewModeMatrix: 'Allgemeine Matrix',
    builderPreviewMissingTranslation: '(keine Übersetzung)',
    builderPreviewWriteAnswer: 'Schreiben Sie Ihre Antwort hier...',
    builderPreviewNoObs: 'Nicht beobachtbar',
    builderPreviewNA: 'N/A',
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Zielgruppe',
    builderNavPreguntas: 'Fragen',
    builderNavConfig: 'Einstellungen',
    builderNavPublicar: 'Veröffentlichen',
    builderNavGuardar: 'Speichern',
    builderInfoTitle: 'Grundlegende Informationen',
    builderSelectAll: 'Alle auswählen',
    langEn: 'Englisch',
    langDe: 'Deutsch',
    langPt: 'Portugiesisch',
    langFr: 'Französisch',
    langNl: 'Niederländisch',
    langRo: 'Rumänisch',
    builderTrlPlaceholderIn: 'auf',
    builderTrlPlaceholderOpt: 'Option',
    builderTrlNoText: 'Noch kein Text',
    // New keys added during refactor
    builderLinkedTo: 'Verknüpft mit',
    builderSelectedIcon: 'Ausgewählt',
    builderHidePreview: 'Vorschau ausblenden',
    builderShowPreview: 'Vorschau anzeigen',
    builderPreviewMorePersons: 'weitere Personen',
    builderPreviewOption1: 'Option 1',
    builderPreviewOption2: 'Option 2',
    builderPreviewViewIn: 'Anzeigen in:',
    builderFromOU: 'aus',
    builderWillReceiveSurvey: 'erhalten diese Umfrage',
    builderPersonsCount: 'Personen',
    builderPersonsPlural: 'Personen',
    builderPersonSingular: 'Person',
    builderInternalIdPlaceholder: 'Z.B. Grundlagen Q1 2026',
    builderMeetingIdPlaceholder: 'Z.B. 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Option',
    builderRemovePerson: 'Entfernen',
    builderSaveTemplateMock: 'Als Vorlage gespeichert ✓',
    builderPublishGlobalLabel: 'Global (exkl. Europa)',
    builderTypeRating: 'Bewertung (1-4)',
    builderTypeMultiple: 'Mehrfachauswahl',
    builderTypeOpen: 'Offene Frage',
    builderTypeBehaviors: 'Verhaltensweisen',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'System',
    // Monitor tab
    monitorTab: 'Überwachung',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'AD-Synchronisierungsjobs',
    subtitle: 'Status, Verlauf und manuelle Ausführung der Jobs, die OUs und Benutzer aus Azure AD synchronisieren.',
    ouCatalogSync: 'OU-Synchronisierung',
    userCatalogSync: 'Benutzersynchronisierung',
    statusNeverRun: 'Nie ausgeführt',
    statusRunning: 'Läuft…',
    statusSuccess: 'Erfolg',
    statusSkipped: 'Übersprungen',
    statusFailed: 'Fehler',
    lastRun: 'Letzte Ausführung',
    duration: 'Dauer',
    triggerScheduled: 'Automatisch',
    triggerManual: 'Manuell',
    created: 'Erstellt',
    updated: 'Aktualisiert',
    unchanged: 'Unverändert',
    skipReason: 'Grund',
    errorMessage: 'Fehler',
    nextScheduled: 'Nächste automatische Ausführung',
    nextScheduledUnknown: 'Wird nach dem ersten Lauf berechnet',
    runNow: 'Jetzt ausführen',
    runningDisabled: 'Läuft bereits',
    viewHistory: 'Verlauf anzeigen',
    hideHistory: 'Verlauf ausblenden',
    historyEmpty: 'Noch keine Ausführungen aufgezeichnet.',
    historyLoading: 'Verlauf wird geladen…',
    historyError: 'Verlauf konnte nicht geladen werden.',
    colDate: 'Datum',
    colTrigger: 'Auslöser',
    colStatus: 'Status',
    colDuration: 'Dauer',
    colDetail: 'Detail',
    triggerError: 'Job konnte nicht ausgeführt werden.',
    triggerConflict: 'Der Job läuft bereits — bitte warten, bis er fertig ist.',
  },
  monitor: {
    title: 'Pipeline-Monitor',
    subtitle: 'Audit der Meeting-Eligibility-Ereignisse, die vom Regelwerk verarbeitet wurden.',
    refresh: 'Aktualisieren',
    lastFetch: 'Zuletzt abgerufen',
    loading: 'Ereignisse werden geladen…',
    timeout: 'Zeitüberschreitung',
    unknownError: 'Unbekannter Fehler',
    empty: 'Keine Pipeline-Ereignisse gefunden.',
    eligible: 'Berechtigt',
    ineligible: 'Nicht berechtigt',
    sampled: 'Ausgewählt',
    excluded: 'Ausgeschlossen',
    samplingApplied: 'Max. Stichprobenentnahme angewendet',
    noParticipants: 'Keine Teilnehmer erfasst.',
    statTotal: 'Ereignisse gesamt',
    statEligible: 'Berechtigte Meetings',
    statAvgSampled: 'Ø ausgewählte Teilnehmer',
    statAvgSampledSub: 'Pro berechtigtem Meeting',
    statSampling: 'Mit max. Stichprobe',
    statSamplingSub: 'Teilnehmerlimit angewendet',
    colMeetingId: 'Meeting-ID',
    colDate: 'Datum',
    colDuration: 'Dauer',
    colEvaluated: 'Geprüft',
    colEligible: 'Berechtigt',
    colSampled: 'Ausgewählt',
    colMaxPax: 'Max',
    colResult: 'Ergebnis',
    colUserId: 'Benutzer-ID',
    colOu: 'OU',
    colTimezone: 'Zeitzone',
    colToday: 'Heute',
    colWeek: 'Woche',
    colInterval: 'Intervall',
    colStatus: 'Status',
    colReason: 'Grund',
    colSample: 'Versand',
    instancesTitle: 'Zugewiesene Umfragen',
    instancesBtnTitle: 'Umfragen dieses Teilnehmers anzeigen',
    instancesLoading: 'Umfragen werden geladen…',
    instancesEmpty: 'Keine Umfrageinstanzen für diesen Teilnehmer in diesem Meeting gefunden.',
    instancesSurvey: 'Umfrage',
    instancesStatus: 'Status',
    instancesExpires: 'Läuft ab',
    instancesDownload: 'JSON herunterladen',
    instancesClose: 'Schließen',
    sortAsc: 'Aufsteigend sortieren',
    sortDesc: 'Absteigend sortieren',
    recalculate: 'Antworten neu berechnen',
    recalculateTitle: 'Antwortanzahl für alle Umfragen neu berechnen',
    recalculateSuccess: 'Neuberechnung abgeschlossen: {{count}} Umfrage(n) aktualisiert.',
    recalculateError: 'Fehler bei der Neuberechnung der Antworten.',
    cacheTitle: 'OU-Katalog-Cache',
    cacheLoading: 'Cache wird geprüft…',
    cacheError: 'Der OU-Cache-Status konnte nicht abgerufen werden.',
    cachePopulated: 'Befüllt',
    cacheNotPopulated: 'Nicht befüllt',
    cacheOuCount: 'OUs im Cache',
    cacheLastSynced: 'Letzte Synchronisierung',
    cacheNeverSynced: 'Nie synchronisiert',
  },
  system: {
    title: 'Systemdiagnose',
    subtitle: 'Echtzeitstatus aller Backend-Microservices und Worker.',
    refreshAll: 'Alle aktualisieren',
    refresh: 'Aktualisieren',
    lastChecked: 'Zuletzt geprüft',
    checking: 'Überprüfung…',
    never: 'Nie',
    statusHealthy: 'Gesund',
    statusDegraded: 'Beeinträchtigt',
    statusError: 'Verbindungsfehler',
    showDetails: 'Prüfungen anzeigen',
    hideDetails: 'Prüfungen ausblenden',
    legendTitle: 'Status-Glossar',
    legendHealthyDesc: 'Alle internen Prüfungen des Dienstes haben korrekt geantwortet.',
    legendDegradedDesc: 'Der Dienst antwortet, aber MongoDB, Redis oder Service Bus haben einen Fehler gemeldet.',
    legendErrorDesc: 'Der Dienst konnte vom Frontend nicht erreicht werden (Timeout, CORS oder Dienst ausgefallen).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Abonnements',
    activeMessages: 'Aktive Nachrichten',
    deadLetterMessages: 'Dead Letter',
    environment: 'Umgebung',
    version: 'Version',
    workers: 'Workers',
    workersDesc: 'Status abgeleitet aus Service Bus-Abonnementstatistiken.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Keine Abonnementstatistiken verfügbar.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Fehler',
  },
  analytics: {
    title: 'Führungs-Dashboard',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Vorurteile',
    omissions: 'Auslassungen',
    personal: 'Persönlich',
    score: 'Score',
    responses: 'Antworten',
    participants: 'Teilnehmer',
    period: 'Zeitraum',
    ou: 'Organisationseinheit',
    noData: 'Unzureichende Daten',
    completionRate: 'Abschlussrate',
    avgByCategory: 'Durchschnitt nach Kategorie',
    organization: 'Organisation',
    fundamentalsRadar: 'Grundlagen-Radar',
    heatmapPersonFund: 'Heatmap — Score nach Person und Grundlage',
    moduleInDev: 'Modul in Entwicklung',
    executiveSubtitle: 'Executive-Ansicht',
    exec: {
      ouTech: 'Technologie',
      ouOps: 'Betrieb',
      ouSales: 'Vertrieb',
    },
    tabs: {
      summary: 'Zusammenfassung',
      fundamentals: 'Grundwerte',
      heatmap: 'Heatmap',
      orgNetwork: 'Org-Netzwerk',
      generational: 'Generational',
    },
    filterBar: { allOrg: 'Gesamte Organisation', allBU: 'Alle BUs', allDept: 'Alle Abteilungen', dateFrom: 'Von', dateTo: 'Bis', allFund: 'Alle Grundwerte', clearFilters: 'Filter zurücksetzen' },
    kpi: { evaluations: 'Bewertungen', avgScore: 'Ø Score', responseRate: 'Antwortrate', avgPerDay: 'Ø / Tag', evaluators: 'Bewerter', scale: 'Skala 1–4', noObservables: 'nicht beobachtbar', perDay: 'Umfragen pro Tag', activeParticipants: 'aktive Teilnehmer', ofTotal: 'gesamt' },
    summary: { topBehaviors: 'Top Daily Habits', topDailyHabitsSubtitle: 'Gewohnheiten mit dem höchsten kulturellen Einfluss', oppSubtitle: 'Gewohnheiten mit dem größten Verbesserungspotenzial', opportunities: 'Verbesserungsbereiche', omissionsByUnit: 'Auslassungen nach Einheit', omissionsSubtitle: 'Auslassungsrate nach OU und BU — absteigend sortiert · Klicken Sie auf eine OU, um ihre BUs zu sehen', downloadExcel: 'Excel herunterladen', omitType: 'Typ', omitPeople: 'Personen', omitRate: 'Auslassungsrate', noOmissions: 'Keine wesentlichen Auslassungen', percentileDistribution: 'Verteilung nach Perzentil', percentileSubtitle: 'Prozentsatz der Bevölkerung in jedem Score-Bereich', personsEvaluated: 'bewertete Personen', excellent: 'Exzellent', good: 'Gut', developing: 'In Entwicklung', attention: 'Aufmerksamkeit', fundPositioning: 'Grundwerte-Positionierung', fundPositioningDesc: 'Ranking, höchste/niedrigste Punktzahl und Nicht-Beobachtungsrate je Grundwert', highestScore: 'Höchste Punktzahl', lowestScore: 'Niedrigste Punktzahl', mostNoObs: 'Meiste Nicht-Beobachtungen', scoreByOU: 'Score nach Organisationseinheit', scoreByOUSubtitle: 'Klicken Sie auf eine OU, um die Aufschlüsselung nach BU und Abteilung zu sehen', person: 'Person', persons: 'Personen' },
    fundamentals: { title: 'Score nach Grundwert', subtitle: 'Erweitern Sie jeden Grundwert, um seine Daily Habits und die Aufschlüsselung nach OU zu sehen', evalLabel: 'Bew', confPreliminary: 'Vorläufige Daten', confBasedOn: 'Basierend auf {{n}} Bew' },
    heatmap: { title: 'Kulturelle Heatmap', subtitle: 'Tippen Sie auf eine Zeile, um ihre Untereinheiten zu erkunden', unit: 'Einheit', unitOU: 'Organisationseinheit', unitBU: 'Business Unit', unitDept: 'Abteilung', unitPerson: 'Verantwortlicher', allOrg: 'Gesamte Organisation', hint: 'Tippen Sie auf eine Zeile, um die nächste Ebene zu erkunden →', person: 'Person', persons: 'Personen', legendCritical: 'Kritisch', legendLow: 'Niedrig', legendMedium: 'Mittel', legendGood: 'Gut', legendExcellent: 'Ausgezeichnet', noOu: 'Ohne OU' },
    ona: { title: 'Org-Netzwerk (ONA)', subtitle: 'Interaktiver Baum der Organisationseinheiten (OU)', treeHint: 'Erweitern Sie jeden Knoten, um die OU-Ebenen der Organisation zu navigieren.', omissions: 'Auslassungen', totalPeople: 'Personen', avgScore: 'Ø Score', totalEvals: 'Bewertungen gesamt', collaboratorsKpi: 'Mitarbeiter', highestOmission: 'Höchste Auslassung', omissionsRanking: 'Auslassungs-Ranking', maturityCulture: 'Kulturelle Reife', maturityLegend: 'Reifegradlegende', maturityInitial: 'Initial', maturityGrowing: 'Wachsend', maturityConsolidated: 'Konsolidiert', maturityRoleModel: 'Vorbild', evalsLabel: 'Bewertungen', noEvals: 'Keine Bewertungen', collaboratorsLabel: 'Mitarbeiter', omissionLabel: 'Auslassung', evalsShort: 'Bew' },
    gen: { panorama: 'Panorama', ranking: 'Ranking', brechas: 'Lücken', avgAge: 'Durchschnittsalter', title: 'Generationsanalyse', subtitle: 'Kulturelle Verteilung und Reife nach Kohorte · {{n}} Personen zugeordnet', noRepresentation: 'Keine Repräsentation', scoreLabel: 'Score', omissionLabel: 'Auslassung', personas: 'Personen', age: 'Alter', all: 'Alle', noData: 'Keine Daten für diesen Filter', fundamental: 'Fundamental', gapCol: 'Δ Lücke', brechaNote: 'Größte Lücke: {{fund}} · Δ {{delta}} Pkt zwischen Generationen', brechaSource: 'Abweichung vom Gesamtdurchschnitt des Grundwerts in der Organisation', responseCount: '{{n}} Antworten' },
  },
  userConfig: {
    fabTitle: 'Benutzerprofil konfigurieren',
    title: 'Benutzerprofil (Demo)',
    subtitle: 'Testmodus — simuliert Daten, die bei der Integration von Teams SSO kommen',
    nombre: 'Name',
    correo: 'E-Mail',
    ou: 'OU (Organisationseinheit)',
    do_: 'DO (Abteilung)',
    bu: 'BU (Geschäftsbereich)',
    departamento: 'Abteilung',
    puesto: 'Position',
    numeronomina: 'Mitarbeiternummer',
    role: 'Rolle',
    roleDetected: 'Erkannte Rolle',
    roleNotFound: 'E-Mail nicht gefunden — Mitarbeiter-Rolle wird verwendet',
    save: 'Profil speichern',
    namePlaceholder: 'z.B.: Ana García',
    emailPlaceholder: 'z.B.: agarcia@sigma.com',
    ouPlaceholder: 'z.B.: Technologie',
    doPlaceholder: 'z.B.: IT-Abteilung',
    buPlaceholder: 'z.B.: Deutschland',
    deptPlaceholder: 'z.B.: Softwareentwicklung',
    puestoPlaceholder: 'z.B.: Senior Software-Ingenieur',
    nominaPlaceholder: 'z.B.: 123456',
    fechaNacimiento: 'Geburtsdatum',
    tenant: 'Mandant',
  },
  errors: {
    generic: 'Ein unerwarteter Fehler ist aufgetreten',
    unauthorized: 'Sie haben keine Berechtigung für diese Aktion',
    notFound: 'Ressource nicht gefunden',
    network: 'Verbindungsfehler. Überprüfen Sie Ihr Netzwerk.',
  },
};

export default de;

